import * as actions from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function popUpToastMessageReducer(state = initialstate.popUpToastMessage, action) {
	switch (action.type) {
        case actions.SET_GENERAL_TOAST_MESSAGE: {
            return {
                ...action.messageContent
            };
        }
        case actions.CLEAR_GENERAL_TOAST_MESSAGE: {
            return null;
        };
        default:
            return state;
    }
}